import { ParallaxBanner } from "@amx/ux-twoui-parallax";
import { TwoUIProgressViewOperationData } from "@amx/ux-twoui-telemetry";
import React from "react";
import { BaseProps } from "../../../shared/props";
import { Image } from "../../Image/Image";
import { ImageFit, ImageGradientType, ImageProps } from "../../Image/Image.types";
import { ShimmerProgressView } from "../../Shimmer/ShimmerProgressView/ShimmerProgressView";
import { Stack } from "../../Stacks/Stack/Stack";
import { FeatureHeight, ParallaxFeatureImageProps } from "../Feature.types";
import { backgroundHeightMapping } from "../FeatureLayout/FeatureLayout";
import { FeatureImageShimmer } from "./FeatureImageShimmer/FeatureImageShimmer";

export interface FeatureImageProps extends BaseProps {
    /**
     * Feature image.
     */
    readonly imageProps: ImageProps | ParallaxFeatureImageProps;
    /**
     * Height of the feature component. Default is medium.
     */
    readonly height?: FeatureHeight;
    /**
     * Contains operation data.
     */
    readonly operationData?: TwoUIProgressViewOperationData;

    /**
     * Contains image fit. Cover for full bleed image, center-contain otherwise.
     */
    readonly imageFit?: ImageFit;

    /**
     * Custom image Gradient
     */
    readonly imageGradientType?: ImageGradientType;
}

export const getImageHeight = (height: FeatureHeight): number => {
    return backgroundHeightMapping[height];
};

export const FeatureImage: React.FC<FeatureImageProps> = ({
    imageProps,
    height = "medium",
    operationData,
    imageFit,
    imageGradientType,
}) => {

    let imageBlock;
    if (imageProps.imageType === "parallax") {
        imageBlock = (
            <Stack borderRadius={imageProps.borderRadius} overflow="hidden" width="100%" height="100%">
                <ParallaxBanner
                    height={getImageHeight(height)}
                    layers={
                        imageProps.imageLayers.map(layer => (
                        {
                            ...layer,
                            children: <Image src={layer.imageSrc} imageType="ariaHiddenImage" imageFit="cover" width="100%" height="100%" />,
                        }))
                    }
                />
            </Stack>
        );
    } else {
        imageBlock = <Image {...imageProps} height={getImageHeight(height)} imageFit={imageFit} imageGradientType={imageGradientType} />;
    }

    if (operationData) {
        return (
            <ShimmerProgressView
                operationData={operationData}
                firstLoadView={<FeatureImageShimmer height={height} />}
                finishedView={imageBlock}
            />
        );
    } else {
        return imageBlock;
    }
};
